module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Bag2-1f63b011a57ad412d7b019e1908911ab.svg";